// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"18":"0af8cc3c","586":"595195c2","606":"95ce2e1c","775":"94ee720f"}[chunkId] + ".js";
};